import { BadgeType } from '@amzn/meridian/badge/badge'
import {
    ColumnAlignmentVertical,
    ColumnHeight,
} from '@amzn/meridian/column/column'
import { LinkType } from '@amzn/meridian/link/link'
import { MastheadSize } from '@amzn/meridian/masthead/masthead'
import {
    SheetSide,
    SheetSpacingInset,
    SheetType,
} from '@amzn/meridian/sheet/sheet'
import { TextType } from '@amzn/meridian/text/text'

// tool bar
export const navBarConfig = {
    MASTHEAD_ID: 'navbar-masthead-wrapper',
    NAVBAR_BADGE_COLOUR: 'error' as BadgeType,
    NAVBAR_HEIGHT: '3.7em',
    NAVBAR_SIZE: 'large' as MastheadSize,
    TOOL_NAME_TEXT_SIZE: 'h300' as TextType,
    TOOL_NAME_DEFAULT_TEXT: 'Welcome',
    TOOL_USERNAME_SIZE: 'b100' as TextType,
    TOOL_STORE_ID_SIZE: 'b100' as TextType,
    TOOL_USERNAME_STORE_ID_SEPARATOR_SIZE: 'b100' as TextType,
}

// tool menu
export const sideBarConfig = {
    SIDEBAR_TYPE: 'overlay' as SheetType,
    SIDEBAR_LINK_TYPE: 'secondary' as LinkType,
    SIDEBAR_PADDING: 'none' as SheetSpacingInset,
    SIDEBAR_POSITION: 'left' as SheetSide,
    TOOL_LIST_HEADER_SIZE: 'h100' as TextType,
    SIDEBAR_VERTICAL_ALIGNMENT: 'top' as ColumnAlignmentVertical,
    SIDEBAR_HEIGHT: '100vh' as ColumnHeight,
    SIDEBAR_WIDTH: 300 as number,
}

export const bottomNavConfig = {
    BOTTOM_NAV_HEIGHT: '4.5em',
    TOOL_ICON_SIZE: 40,
}

export const IFRAME_HEIGHT: ColumnHeight = '100%'
export const IFRAME_PARENT_CONTAINER_HEIGHT: ColumnHeight = '100%'

// decides to display zone or tool selection within sidebar
export enum SideBarMode {
    ZONE_SELECT,
    TOOL_SELECT,
}
